<template>
  <div class="notes-page" v-if="order">
    <div class="title-payment">
      <p>Notes</p>
      <button @click="showModalAddNote = true">+</button>
    </div>

    <table class="mt-3">
      <tr v-for="(note, index) in order.order_info.notes" :key="index">
        <th style="width: 70%" class="name-add">
          {{ note.split(']')[1] }}
        </th>
        <th style="width: 30%" class="text-payment">{{ note.split(']')[0].replace('[', '') }}</th>
      </tr>

    </table>
    <modal-add-note :title="'Add note'" v-if="showModalAddNote" @close="showModalAddNote = false">
      <textarea class="text-note mt-3" name="text-notes" cols="30" v-model="newNote" rows="10" placeholder="Notes"></textarea>
      <div class="d-flex justify-content-between mt-3">
        <button @click="showModalAddNote = false" class="btn-dialog">Cancel</button>
        <button class="btn-dialog ok-btn" @click="saveNote">Ok</button>
      </div>
    </modal-add-note>
  </div>
</template>

<script>
import ModalAddNote from './Modal/AddOption.vue'
import {EventBus} from "@/utils/event-bus";
import DibbleAPI from "@/api";
import DibbleJS from "@/dibble";
import DibbleApi from "@/api";

export default {
  name: "Payments",
  data() {
    return {
      orderId: this.$route.params.id,
      order: null,
      showModalAddNote: false,
      newNote: ''
    };
  },
  components: {
    ModalAddNote
  },
  created() {
    EventBus.$emit("currentViewOrderId", this.orderId);
    this.loadOrderInfo();
  },
  methods: {
    loadOrderInfo() {
      const params = {
        request: DibbleAPI.api.adminGetRentalBoatOrder,
        order_id: this.orderId
      }
      DibbleJS.showLoader();
      DibbleJS.callApiRequest(params, this._onLoadOrderSuccess, this._onLoadOrderFailed)
    },
    _onLoadOrderSuccess(response) {
      DibbleJS.hideLoader();
      if (DibbleApi.isResponseSuccess(response)) {
        this.order = this.orderOrigin = response;
      } else {
        DibbleJS.toastErrorMessage(response.message)
      }
    },
    _onLoadOrderFailed() {
      DibbleJS.hideLoader();
      DibbleJS.toastErrorMessage('Something wrong! can not load data');
    },
    saveNote() {
      const params = {
        request: DibbleApi.api.addRentalBoatNote,
        order_id: this.orderId,
        note: this.newNote
      };
      DibbleJS.showLoader();
      DibbleJS.callApiRequest(params, response => {
        DibbleJS.hideLoader();
        if (DibbleApi.isResponseSuccess(response)) {
          DibbleJS.toastSuccessMessage(response.message);
          this.newNote = "";
          this.onNewNoteSaved();
        } else {
          DibbleJS.toastErrorMessage(response.message);
        }
      });
    },
    onNewNoteSaved() {
      this.showModalAddNote = false
      this.loadOrderInfo()
    }
  },
};
</script>

<style lang="scss" scoped>
.notes-page {
  margin: 20px 70px;
  display: flex;
  flex-direction: column;
  user-select: none;
  min-width: 900px;

  p {
    font-family: "Open Sans";
    font-style: normal;
  }

  .title-payment {
    display: flex;
    justify-content: space-between;

    p {
      font-weight: 600;
      font-size: 22px;
      color: #1c5169;
    }

    button {
      background: #1c5169;
      box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
      border-radius: 20px;
      width: 61px;
      height: 47px;
      color: #fff;
      font-size: 30px;
      border: none;
    }
  }

  table {
    width: 100%;
    user-select: none;

    tr {
      user-select: none;
      border-bottom: 1.5px solid #dee6ea;
    }

    th {
      padding-top: 20px;
      padding-bottom: 20px;
      user-select: none;
    }

    .name-add {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      color: #555E67;
    }

    .text-payment {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      color: #7c7c7a;
    }
  }

  // dialog
  .text-note {
    min-height: 200px;
    width: 100%;
    background: #E8EFF1;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: #7C7C7A;
    padding: 20px;
    border: none;
  }

  .btn-dialog {
    width: 180px;
    height: 60px;
    background: #D9D9D9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 18px;
    text-align: center;
    color: #FFFFFF;
    border: none;
  }

  .ok-btn {
    background: #2178ab;
    color: #FFFFFF;
  }
}
</style>
